if (!customElements.get('app-swiper')) {
  customElements.define(
    'app-swiper',
    class AppSupport extends HTMLElement {
      constructor() {
        super();

        this.swiper = new Swiper('.swiper', {
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-navigation-next',
            prevEl: '.swiper-navigation-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          }
        });
      }
    },
  );
}
